import React from 'react';
import noop from 'lodash/noop';
import styled from 'styled-components';
import { Box, SparkContentLoader, Text } from '@sparknz/spark-pattern-library';

import { useSelectedPlans } from '../../providers';
import { pluralize } from '../../utils/pluralize';
import BottomBarActions from './BottomBarActions';
import BottomBarContainer from './BottomBarContainer';

const StyledBox = styled(Box)`
  white-space: nowrap;
`;

export default function BottomBarLoader() {
  const { totalSelectedPlansQuantity } = useSelectedPlans();

  if (totalSelectedPlansQuantity < 1) {
    return null;
  }

  const plansQuantityText = `${totalSelectedPlansQuantity} ${pluralize({
    quantity: totalSelectedPlansQuantity,
    word: 'plan',
  })}:`;

  return (
    <BottomBarContainer>
      <div>
        <div>
          <StyledBox flexDirection="row">
            <Text component="span" variant="bodySDemi">
              {plansQuantityText}&nbsp;
            </Text>
            <SparkContentLoader height={22} style={{ width: '100%' }}>
              <rect x="4" y="2" rx="4" ry="4" width="40%" height="20" />
            </SparkContentLoader>
          </StyledBox>
          <SparkContentLoader height={20} style={{ width: '100%' }}>
            <rect x="0" y="2" rx="4" ry="4" width="80%" height="18" />
          </SparkContentLoader>
        </div>
        <BottomBarActions
          disabled
          openMpdSelectionActionLayer={noop}
          planCardsProducts={[]}
        />
      </div>
    </BottomBarContainer>
  );
}
